/**
* @summary - Component that Provides PPM SCHEDULE functionality
* @autor vengateshwaran k
* @since 2024-06-21
*/
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton, Stack,
} from "@mui/material";
import { format } from 'date-fns';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import assetServiceChangeRepository from "../../api/repositories/assetServiceRepository";
import commonMasterRepository from "../../api/repositories/commonMasterRepository";
import PPMCheckListRepository from "../../api/repositories/ppmChecklistRepository";
import { DefaultCard } from "../../assets/styled-components/card";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import { getAuthToken } from "../../utility/tokenUtility";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDialog from '../commoncomponents/CustomDialog';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextFieldWithSearch from '../commoncomponents/CustomTextFieldWithSearch';
import PageLoader from "../commoncomponents/PageLoader";
import RefreshExportButtons from '../commoncomponents/RefreshExportButtons';

const AssetServiceChangeList = ({ facilityId, companyId }) => {
  const dispatch = useDispatch();
  const [assetNoOptions, setAssetNoOptions] = useState([]);
  const [assetNo, setAssetNo] = useState();
  const [currentService, setCurrentService] = useState();
  const [currentWorkGroup, setCurrentWorkGroup] = useState();
  const [currentTypeCode, setCurrentTypeCode] = useState();
  const [typeCodeOptions, setTypeCodeOptions] = useState([]);
  const [newTypeCode, setNewTypeCode] = useState();
  const [errors, setErrors] = useState({});  // State to track validation errors
  const [reason, setReason] = useState();
  const [assetDescription, setAssetDescription] = useState();
  const [gridApi, setGridApi] = useState({});
  const [serviceType, setServiceType] = useState();
  const [serviceTypeOptions, setServiceTypeOptions] = useState([]);
  const [workGroup, setWorkGroup] = useState();
  const [workGroupOptions, setWorkGroupOptions] = useState([]);
  const [workGroupDescription, setWorkGroupDescription] = useState();
  const [allRows, setAllRows] = useState([]);
  const [allWoAffectedRows, setAllWoAffectedRows] = useState([]);
  const navigate = useNavigate();
  const [regenerateDialogOpen, setRegenerateDialogOpen] = useState(false);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [assetClassificationOptions, setAssetClassificationOptions] = useState([]);
  const [assetClassification, setAssetClassification] = useState(assetClassificationOptions?.find((item) => item?.label === "Asset"));
  const [openDialogue, setOpenDialogue] = useState();
  const [open, setOpen] = useState(false);
  const [gridApis, setGridApis] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = getAuthToken('id_token');
  const colDefs = [
    {
      headerName: "History of Changes For Selected Asset",
      headerClass: "header-centered",
      children: [
        {
          field: "assetno", headerName: "Asset Number",

        },
        {
          headerName: "Changed From",
          headerClass: "header-centered",
          children: [{
            field: "curservice", headerName: "Service", headerClass: 'ag-header-cell-inline-center'

          },

          {
            field: "curwgcode", headerName: "Work Group", headerClass: 'ag-header-cell-inline-center'

          },
          {
            field: "curtypecode", headerName: "Type Code",

          },
          ]
        },
        {
          headerName: "Changed To",
          headerClass: "header-centered",
          children: [{
            field: "newservice", headerName: "Service",

          },

          {
            field: "newwgcode", headerName: "Work Group",

          },
          {
            field: "newtypecode", headerName: "Type Code",

          },
          ]
        },
        {
          headerName: "Reason & Work Order Affected",
          headerClass: "header-centered",
          children: [

            {
              field: "changedate", headerName: "Date",

            },

            {
              field: "remarks", headerName: "Reason",

            },
            {
              field: "WOAffected", headerName: "WO Affected",
              cellRenderer: ({ data }) => (
                <>
                  <span
                    style={{
                      display: "block",
                      margin: "4px 0px",
                      cursor: "pointer",
                      textAlign: "center",
                      textDecoration: 'underline',
                      color: 'blue'
                    }}
                    onClick={() => handleWoAffected(data)}
                  >
                    WO AFFECTED
                  </span>
                </>
              ),

            }]
        },],
      headerClass: 'ag-header-cell-inline-center'
    }
  ];
  const handleAssetClick = async (newValue) => {
    if (newValue?.label === '') {
      setAssetNo({ label: '', value: '' });
      setCurrentService('');
      setCurrentWorkGroup('');
      setCurrentTypeCode('');
      setReason('');
      setServiceType(null);
      setWorkGroup(null);
      setNewTypeCode(null);
      setWorkGroupDescription('');
      setAllRows([]);
      setAssetDescription('');
      setAssetClassification({ label: '', value: '' });
      setNewTypeCode({ label: '', value: '' })
      setIsChanged(false);
    }
    else {
      let assetClassificationOptions = await PPMCheckListRepository.getBemsAssetClassification();
      setAssetClassification(assetClassificationOptions?.find((item) => item?.id == newValue?.classificationId) || assetClassificationOptions?.find((item) => item?.label === "Asset"));
      setAssetNo({ ...newValue, label: newValue?.value });
      setCurrentService(newValue?.serviceName);
      setCurrentWorkGroup(newValue?.workGroup);
      setCurrentTypeCode(newValue?.typeCode);
      setErrors({ ...errors, assetNo: null });
      setAssetDescription(newValue?.assetdesc);
      setIsChanged(true);
    }
    // Close the modal after asset selection
    handleCloseModal();
  };
  const columns = [
    {
      headerName: 'Asset No',
      field: 'label',
      width: 150,
      cellRenderer: (params) => (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleAssetClick(params.data);
          }}
          style={{
            color: 'blue',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          {params.value}
        </a>
      ),
    },
    { headerName: 'Description', field: 'assetdesc', width: 200 },
    { headerName: 'Service', field: 'serviceName', width: 100 },
    { headerName: 'Work Group ', field: 'workGroup', width: 150, },
    { headerName: 'Work Group Description', field: 'wgdesc', width: 150, }

  ];
  const handleWoAffected = async (data) => {
    try {
      if (data) {
        if (data?.newservice === 'FEMS') {
          const result = await assetServiceChangeRepository.getFemsWoAffected(data?.newassetid);
          const list = result?.data?.map((item) => {
            return {
              ...item,
              date: format(new Date(item?.date), "dd/MM/yyyy"),
            }
          });
          setAllWoAffectedRows(list);
          setOpen(true);
        } else if (data?.newservice === 'BEMS') {
          const result = await assetServiceChangeRepository.getBemsWoAffected(data?.newassetid);
          const list = result?.data?.map((item) => {
            return {
              ...item,
              date: format(new Date(item?.date), "dd/MM/yyyy"),
            }
          });
          setAllWoAffectedRows(list);
          setOpen(true);
        }
      }
    }
    catch (e) {
      console.error(e);
    }
  };

  const resultsColDefs = [
    { field: "workorderno", headerName: "Work Order No" },
    { field: "date", headerName: "Date" },
    { field: "workorderstatus", headerName: "Status" },
  ];
  const handleClose = () => {
    setOpenDialogue(false);
    setOpen(false);

  };

  const fetchWorkOrderAffectedData = async () => {
    //      if (open) {
    try {

    }
    catch (e) {
      console.log(e)
    }
    //    }
  }
  const handleGridRefreshFetch = async () => {
    await fetchWorkOrderAffectedData();
  }

  const fetchOptions = async () => {
    try {
      setLoading(true);
      const workgroupdetails = await commonMasterRepository.getWorkGroupDetails(facilityId);
      setWorkGroupOptions(workgroupdetails);
      // setWorkGroup(workgroupdetails?.find((item) => item?.label === 'W4'))

      const responseMasters = await commonMasterRepository.getMasters(facilityId, companyId);
      setServiceTypeOptions(responseMasters);
      // setServiceType(responseMasters?.find((item) => item?.label === 'FEMS'))

      const assetNos = await assetServiceChangeRepository.getAssetNoForServiceChange(facilityId);
      const assetNoBems = await assetServiceChangeRepository.getBemsAssetNoForServiceChange(facilityId);
      const joinedArray = assetNos.concat(assetNoBems);
      setAssetNoOptions(joinedArray);

      const typeCode = await assetServiceChangeRepository.getTypeCodeForServiceChange(facilityId, companyId);
      setTypeCodeOptions(typeCode);


    }
    catch (e) {
      console.log(e)
    }
    finally {
      setLoading(false);
    }

  }
  useEffect(() => {
    fetchOptions();
  }, [])

  const fetchAllAsset = async (assetNumber) => {
    try {
      setLoading(true);
      const assetNos = await assetServiceChangeRepository.getAssetNoForServiceChange(facilityId);
      const assetNoBems = await assetServiceChangeRepository.getBemsAssetNoForServiceChange(facilityId);
      const joinedArray = assetNos.concat(assetNoBems);
      setAssetNoOptions(joinedArray);
      setAssetNo(joinedArray?.find((item) => item?.value === assetNo?.value));
    } catch (e) {
      console.error(e);
    }
    finally {
      setLoading(false);
    }
  }
  const serviceTypeChange = useMemo(() => {
    const fetchOptions = async () => {
      try {
        if (serviceType?.label === 'BEMS') {
          const workgroupdetails = await commonMasterRepository.getBemsWorkGroupDetails(facilityId);
          setWorkGroupOptions(workgroupdetails?.filter((item) => item?.value != currentWorkGroup));
          let assetClassificationOptions = await PPMCheckListRepository.getBemsAssetClassification();
          setAssetClassificationOptions(assetClassificationOptions);
          //setWorkGroup(workgroupdetails?.find((item) => item?.label === 'W8'))


        }
        if (serviceType?.label === 'FEMS') {
          const workgroupdetails = await commonMasterRepository.getWorkGroupDetails(facilityId);
          setWorkGroupOptions(workgroupdetails?.filter((item) => item?.value != currentWorkGroup));
          //setWorkGroup(workgroupdetails?.find((item) => item?.label === 'W4'))
          let assetClassificationOptions = await PPMCheckListRepository.getBemsAssetClassification();
          setAssetClassificationOptions(assetClassificationOptions?.filter((item) => item?.label != "Doctor`s Asset"));


        }
      }
      catch (e) {
        console.log(e)
      }

    }
    fetchOptions();
  }, [serviceType]);

  const fetchassetList = async () => {
    try {
      const listValue = await assetServiceChangeRepository.getAssetServiceChangeList(
        assetNo?.label,
        token
        // 'H65FE00785'
      );

      const list = listValue?.data?.map((item) => {
        return {
          ...item,
          changedate: format(new Date(item?.changedate), "dd/MM/yyyy"),
        }
      });
      setAllRows(list);
      setCurrentService(assetNo?.serviceName);
      setCurrentWorkGroup(assetNo?.workGroup);
      setCurrentTypeCode(assetNo?.typeCode);
      setErrors({ ...errors, assetNo: null });
      setAssetDescription(assetNo?.assetdesc);
      // setWorkGroupDescription(assetNo?.wgdesc);
      // setCurrentService(assetNo?.currentService)
      // if(assetNo?.workGroup!="W8"){
      //   setCurrentService('FEMS')

      // }else{
      //   setCurrentService('BEMS')
      // }
    }
    catch (e) {
      console.error(e)
    }

  }
  const assetNoChange = useMemo(() => {
    if (assetNo?.label != '') {
      fetchassetList();
    }

  }, [assetNo, openDialogue]);

  const assetService = useMemo(() => {
    const getTypeCodes = async () => {
      try {
        //  let assetClassificationId = location.state.mode != "create" ? location?.state?.MasassetclassificationId : assetClassification?.id;
        const typeCodeOptions = serviceType?.label === "FEMS" ? await PPMCheckListRepository.getTypeCode(companyId, "2f702577-5b94-4975-9367-e1b3721f6e7a", assetClassification?.id) : await PPMCheckListRepository.getTypeCode(companyId, "a9a74b9a-2319-4ee3-861d-005e00938b22", assetClassification?.id);
        setTypeCodeOptions(typeCodeOptions);

      }
      catch (e) {
        console.error(e)
      }
    }
    if (assetClassification?.label != '') {
      getTypeCodes();
    }
  }, [assetClassification])

  const handleInitiate = async () => {
    const newErrors = {};
    if (!assetNo?.label) newErrors.assetNo = "Asset No is required";
    if (!serviceType?.label) newErrors.serviceType = "New Service is required";
    if (!newTypeCode?.label) newErrors.newTypeCode = "New Type Code is required";
    if (!workGroup?.label) newErrors.workGroup = "New Work Group is required";
    // if (!assetClassification?.label) newErrors.assetClassification = "Asset Classification is required";
    if (!reason) newErrors.reason = "Reason is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else if (isChanged === true) {
      setIsChanged(false);
      setErrors({});
      try {
        const updatePayload = {
          assetId: assetNo?.id,
          workGroupId: workGroup?.id,
          typeCodeId: newTypeCode?.id

        }
        const currentDate = new Date();
        const formattedDate = format(currentDate, "yyyy-MM-dd'T'HH:mm:ss");
        setLoading(true);
        const postFemsPayload = {
          assetno: assetNo?.label,
          curwgcodeid: assetNo?.workGroupId,
          newwgcodeid: workGroup?.id,
          curtypecodeid: newTypeCode?.id,
          newtypecodeid: newTypeCode?.id,
          remarks: reason,
          curwgcode: assetNo?.workGroup,
          newwgcode: workGroup?.label,
          curtypecode: currentTypeCode,
          curservice: currentService,
          newservice: serviceType?.label,
          femassetregisterid: assetNo?.id,
          femassetservicechangeaffectedentities: [],
          isdeleted: false,
          newtypecode: newTypeCode?.label,
          changedate: formattedDate
        }
        const postBemsPayload = {
          assetno: assetNo?.label,
          curwgcodeid: assetNo?.workGroupId,
          newwgcodeid: workGroup?.id,
          curtypecodeid: newTypeCode?.id,
          newtypecodeid: newTypeCode?.id,
          remarks: reason,
          curwgcode: assetNo?.workGroup,
          newwgcode: workGroup?.label,
          curtypecode: currentTypeCode,
          curservice: currentService,
          newservice: serviceType?.label,
          bemassetregisterid: assetNo?.id,
          bemassetservicechangeaffectedentities: [],
          newtypecode: newTypeCode?.label,
          isdeleted: false,
          changedate: formattedDate
        }

        if (currentService === 'FEMS') {
          if (serviceType?.label === "FEMS") {
            const response = await assetServiceChangeRepository.deleteFemsData(assetNo?.id, workGroup?.id, token)
            if ((response.status >= 200 && response.status <= 204)) {
              const updatePayloads = {
                assetId: response?.data[0]?.id,
                workGroupId: workGroup?.id,
                typeCodeId: newTypeCode?.id
              }
              const responseFems = await assetServiceChangeRepository.updateFemsService(updatePayloads, response?.data[0]?.id);
              if (responseFems.status >= 200 && responseFems.status <= 204) {
                let newPostFemsPayload = { ...postFemsPayload, newassetid: response?.data[0]?.id }
                const reponseFemsFinal = await assetServiceChangeRepository.postFemsAssetService(newPostFemsPayload);
                if (reponseFemsFinal.status >= 200 && reponseFemsFinal.status <= 204) {
                  setIsChanged(false);
                  await handleRefresh();
                  await fetchAllAsset(assetNo?.value);
                  setConfirmationDialogOpen(true);
                  setAssetClassification(assetClassificationOptions?.find((item) => item?.id == assetNo?.classificationId) || assetClassificationOptions?.find((item) => item?.label === "Asset"));

                }
              }
            }
          } else if (serviceType?.label === "BEMS") {
            const response = await assetServiceChangeRepository.removeFemsService(assetNo?.id, workGroup?.id, token);
            if (response.status >= 200 && response.status <= 204) {
              const updatePayloads = {
                assetId: response?.data[0]?.id,
                workGroupId: workGroup?.id,
                typeCodeId: newTypeCode?.id
              }
              const responseBems = await assetServiceChangeRepository.updateBemsService(updatePayloads, response?.data[0]?.id);
              if (responseBems.status >= 200 && responseBems.status <= 204) {
                let newPostFemsPayload = { ...postFemsPayload, newassetid: response?.data[0]?.id };
                const reponseBemsFinal = await assetServiceChangeRepository.postFemsAssetService(newPostFemsPayload);

                if (reponseBemsFinal.status >= 200 && reponseBemsFinal.status <= 204) {
                  setIsChanged(false);
                  await handleRefresh();
                  await fetchAllAsset(assetNo?.value);
                  setConfirmationDialogOpen(true);
                  setAssetClassification(assetClassificationOptions?.find((item) => item?.id == assetNo?.classificationId) || assetClassificationOptions?.find((item) => item?.label === "Asset"));

                }
              }
            }
          }
        } else if (currentService === 'BEMS') {
          if (serviceType?.label === "FEMS") {
            const response = await assetServiceChangeRepository.removeBemsService(assetNo?.id, workGroup?.id, token);
            if ((response.status >= 200 && response.status <= 204)) {
              const updatePayloads = {
                assetId: response?.data[0]?.id,
                workGroupId: workGroup?.id,
                typeCodeId: newTypeCode?.id
              }
              const responseFems = await assetServiceChangeRepository.updateFemsService(updatePayloads, response?.data[0]?.id);
              if (responseFems.status >= 200 && responseFems.status <= 204) {
                let newPostBemsPayload = { ...postBemsPayload, newassetid: response?.data[0]?.id };
                const reponseFemsFinal = await assetServiceChangeRepository.postBemsAssetService(newPostBemsPayload);
                if (reponseFemsFinal.status >= 200 && reponseFemsFinal.status <= 204) {
                  setIsChanged(false);
                  await handleRefresh();
                  await fetchAllAsset(assetNo?.value);
                  setConfirmationDialogOpen(true);
                  setAssetClassification(assetClassificationOptions?.find((item) => item?.id == assetNo?.classificationId) || assetClassificationOptions?.find((item) => item?.label === "Asset"));

                }
              }
            }
          } else if (serviceType?.label === "BEMS") {
            const response = await assetServiceChangeRepository.deleteBemsData(assetNo?.id, workGroup?.id, token)
            if ((response.status >= 200 && response.status <= 204)) {
              const updatePayloads = {
                assetId: response?.data[0]?.id,
                workGroupId: workGroup?.id,
                typeCodeId: newTypeCode?.id
              }
              const responseBems = await assetServiceChangeRepository.updateBemsService(updatePayloads, response?.data[0]?.id);
              if (responseBems.status >= 200 && responseBems.status <= 204) {
                let newPostBemsPayload = { ...postBemsPayload, newassetid: response?.data[0]?.id }
                const reponseBemsFinal = await assetServiceChangeRepository.postBemsAssetService(newPostBemsPayload);
                if (reponseBemsFinal.status >= 200 && reponseBemsFinal.status <= 204) {
                  setIsChanged(false);
                  await handleRefresh();
                  await fetchAllAsset(assetNo?.value);
                  setConfirmationDialogOpen(true);
                  setAssetClassification(assetClassificationOptions?.find((item) => item?.id == assetNo?.classificationId) || assetClassificationOptions?.find((item) => item?.label === "Asset"));

                }
              }
            }
          }
        }

      } catch (e) {
        console.log(e);
      }
      finally {
        setLoading(false);
      }
    }
  }
  const handleRefresh = async () => {
    setCurrentService('');
    setCurrentWorkGroup('');
    setCurrentTypeCode('');
    setReason('');
    setServiceType(null);
    setWorkGroup(null);
    setNewTypeCode({ label: '', value: '' });
    setAssetClassification({ label: '', value: '' });
    setWorkGroupDescription('');
    setAssetNo({ label: '', value: '' });
    setAssetDescription('');
    setErrors({});
    setAllRows([]);
  }
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleCancelClick = () => {
    navigate("/dashboard");
    dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
    dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
  }
  return (
    <>
      <PageLoader open={loading} />
      <Box mt={{ xs: 1, sm: 2 }}>
        <DefaultCard>
          <Grid container spacing={2}>
            {/* <Grid item xs={6} md={4}>
              <CustomTextFieldWithSearch
                label="Asset No."
                id="assetno"
                value={assetNo}
                isMandatoryField={true}
                error={!!errors?.assetNo}
                errorMessage={errors.assetNo}
                options={assetNoOptions?.map(option => ({
                  ...option,
                  label: `${option.label} - ${option.assetdesc}`,
                }))}
                onChange={async(newValue) => {
                  if (newValue?.label === '') {
                    setAssetNo({ label: '', value: '' });
                    setCurrentService('');
                    setCurrentWorkGroup('');
                    setCurrentTypeCode('');
                    setReason('');
                    setServiceType(null);
                    setWorkGroup(null);
                    setNewTypeCode(null);
                    setWorkGroupDescription('');
                    setAllRows([]);
                    setAssetDescription('');
                    setAssetClassification({ label: '', value: '' });
                    setNewTypeCode({ label: '', value: '' })
                    setIsChanged(false);
                  }
                  else {                   
                    let assetClassificationOptions = await PPMCheckListRepository.getBemsAssetClassification();
                    setAssetClassification(assetClassificationOptions?.find((item) => item?.id == newValue?.classificationId)||assetClassificationOptions?.find((item) => item?.label === "Asset"));
                    setAssetNo({ ...newValue, label: newValue?.value });
                    setCurrentService(newValue?.serviceName);
                    setCurrentWorkGroup(newValue?.workGroup);
                    setCurrentTypeCode(newValue?.typeCode);
                    setErrors({ ...errors, assetNo: null });
                    setAssetDescription(newValue?.assetdesc);
                    setIsChanged(true);
                   }
                }
                }
              />
            </Grid> */}
            <Grid item xs={11.5} md={3.5} sm={5.5}>
              <CustomTextFieldWithSearch
                label="Asset No"
                id="assetno"
                value={assetNo}
                isMandatoryField={true}
                error={!!errors?.assetNo}
                errorMessage={errors.assetNo}
                options={assetNoOptions?.map(option => ({
                  ...option,
                  label: `${option.label} - ${option.assetdesc}`,
                }))}
                onChange={async (newValue) => {
                  if (newValue?.label === '') {
                    setAssetNo({ label: '', value: '' });
                    setCurrentService('');
                    setCurrentWorkGroup('');
                    setCurrentTypeCode('');
                    setReason('');
                    setServiceType(null);
                    setWorkGroup(null);
                    setNewTypeCode(null);
                    setWorkGroupDescription('');
                    setAllRows([]);
                    setAssetDescription('');
                    setAssetClassification({ label: '', value: '' });
                    setNewTypeCode({ label: '', value: '' })
                    setIsChanged(false);
                  }
                  else {
                    let assetClassificationOptions = await PPMCheckListRepository.getBemsAssetClassification();
                    setAssetClassification(assetClassificationOptions?.find((item) => item?.id == newValue?.classificationId) || assetClassificationOptions?.find((item) => item?.label === "Asset"));
                    setAssetNo({ ...newValue, label: newValue?.value });
                    setCurrentService(newValue?.serviceName);
                    setCurrentWorkGroup(newValue?.workGroup);
                    setCurrentTypeCode(newValue?.typeCode);
                    setErrors({ ...errors, assetNo: null });
                    setAssetDescription(newValue?.assetdesc);
                    setIsChanged(true);
                  }
                }
                }
              />
            </Grid>
            <Grid item xs={0.5} md={0.5} sm={0.5} >
              <Grid sx={{ mt: 2.7 }} item>
                <Button
                  onClick={handleOpenModal}
                  variant="contained"
                  sx={{ minWidth: '32px', minHeight: '32px', marginLeft: '0rem' }}
                >
                  <SearchIcon fontSize="small" />
                </Button>
              </Grid>

              <Dialog
                open={isModalOpen}
                onClose={(event, reason) => {
                  if (reason === "backdropClick") {
                    return; // Prevent closing on backdrop click
                  }
                  handleCloseModal(); // Call the close function for other reasons
                }}
                // onClose={handleCloseModal}
                aria-labelledby="asset-grid-dialog"
                aria-describedby="grid-display-for-assets"
                maxWidth="lg"
                fullWidth
              ><DialogTitle
                id="asset-grid-dialog"
                sx={{
                  fontWeight: 'bold',
                  fontSize: '1.5rem', // Adjust font size as desired
                  display: 'flex',
                  justifyContent: 'space-between', // Space out title and icon
                  alignItems: 'center',
                }}
              >
                  Asset Search
                  <IconButton
                    aria-label="close"
                    variant="outlined"
                    onClick={handleCloseModal}
                    sx={{
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent
                  dividers
                  sx={{
                    overflowY: 'auto', // Enables scroll if content overflows
                    height: 'auto',    // Allows height to adjust based on content
                    maxHeight: 'auto', // Sets a maximum height to prevent it from growing too large
                  }}
                >
                  <CustomAgGrid
                    rows={assetNoOptions || []}
                    columns={columns}
                    // loading={loadingAssets}
                    refSet={gridApi}
                    setGridApi={setGridApi}
                  />
                  <Stack my={3} direction={"row"} justifyContent={"end"}>
                    <Button variant="outlined" onClick={handleCloseModal}>
                      Close
                    </Button>
                  </Stack>
                </DialogContent>
              </Dialog>

            </Grid>

            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Asset Description"
                id="Asset Description"
                isRefilByOtherField={true}
                placeholder={false}
                value={assetDescription}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                label="New Service"
                value={serviceType}
                isMandatoryField={true}
                error={!!errors?.serviceType}
                errorMessage={errors.serviceType}
                options={serviceTypeOptions}
                onChange={(newValue) => {
                  setNewTypeCode({ label: '', value: '' });
                  setWorkGroup(null);
                  setServiceType(newValue);
                  setErrors({ ...errors, serviceType: null });
                  if (newValue != null) {
                    setIsChanged(true);
                    setWorkGroupDescription('');
                  }
                }}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Current Type Code"
                id="workgroupdescription"
                isRefilByOtherField={true}
                placeholder={false}
                value={currentTypeCode}
                onChange={(newValue) => {
                  setCurrentTypeCode(newValue);
                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Current Service"

                isRefilByOtherField={true}
                placeholder={false}
                value={currentService}
                onChange={(newValue) => {
                  setCurrentService(newValue)

                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="workgroup"
                label=" New Work Group"
                isMandatoryField={true}
                value={workGroup}
                error={!!errors?.workGroup}
                errorMessage={errors.workGroup}
                options={serviceType != null ? workGroupOptions?.map(option => ({
                  ...option,
                  label: `${option.label} - ${option.wgdesc}`
                })) : []}
                onChange={(newValue) => {
                  if (newValue === null) {
                    setWorkGroup({})
                    setWorkGroupDescription('');
                  } else {
                    setIsChanged(true);
                    setWorkGroup(newValue);
                    setWorkGroup(newValue ? { ...newValue, label: newValue.label.split('-')[0].trimRight() } : '');
                    setWorkGroupDescription(newValue?.wgdesc);
                    setErrors({ ...errors, workGroup: null });
                  }

                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Current Work Group"
                id="workgroupdescription"
                isRefilByOtherField={true}
                placeholder={false}
                value={currentWorkGroup}
                onChange={(newValue) => {
                  setCurrentWorkGroup(newValue);
                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="New Work Group Description"
                id="workgroupdescription"
                isRefilByOtherField={true}
                placeholder={false}
                value={workGroupDescription}
                onChange={(newValue) => {
                  setWorkGroupDescription(newValue);

                }}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="assetclassification"
                label="Asset Classification"
                value={assetClassification}
                error={!!errors?.assetClassification}
                errorMessage={errors.assetClassification}
                isRefilByOtherField={true}
                placeholder={false}
                options={assetClassificationOptions?.sort((a, b) => a.label.localeCompare(b.label))}
                disabled={true}
              // isMandatoryField={true}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomTextFieldWithSearch
                label="New Type Code"
                isMandatoryField={true}
                error={!!errors?.newTypeCode}
                errorMessage={errors.newTypeCode}
                value={newTypeCode}
                options={typeCodeOptions?.map(option => ({
                  label: `${option.label} - ${option.typedescription}`,
                  value: option.value,
                  typedescription: option?.typedescription,
                  id: option?.id
                }))?.sort((a, b) => a.label.localeCompare(b.label))
                }
                onChange={(newValue) => {
                  if (newValue?.label != '') {
                    setIsChanged(true);
                    setNewTypeCode({ ...newValue, label: newValue?.value });
                    setErrors({ ...errors, newTypeCode: null });
                  } else {
                    setNewTypeCode('');
                  }

                }


                }
              />
            </Grid>

            <Grid item xs={6} md={8}>
              <CustomTextField
                label="Reason"
                id="proposed-by"
                //isRefilByOtherField={true}
                isMandatoryField={true}
                error={!!errors?.reason}
                errorMessage={errors?.reason}
                placeholder={false}
                value={reason}
                onChange={(newValue) => {
                  setReason(newValue);
                  setErrors({ ...errors, reason: null });

                }}
              />
            </Grid>

          </Grid>

          <Box
            sx={{
              marginTop: "10px",
              display: "flex",
              gap: 2,
              justifyContent: { xs: "center", md: "end" },
            }}
          >
            <Button variant='contained' onClick={handleInitiate}>Initiate</Button>
            <Button variant='outlined' onClick={handleRefresh}>Refresh</Button>

          </Box>    </DefaultCard></Box>

      <Box mt={{ xs: 1, sm: 2 }}>
        <CustomAgGrid
          ref={gridApi}
          setGridApi={setGridApi}
          rows={allRows}
          columns={colDefs}
          isEnableView={false}
          disableFilter={false}
          headerLayer={4}

        />
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: { xs: "center", md: "end" },
          }}
        >
          <Grid container spacing={2}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: "60px", marginRight: "20px" }}>

              <Button variant='outlined' onClick={handleCancelClick} sx={{ margin: "10px" }}>Back</Button>

            </Grid>
          </Grid>
        </Box>

      </Box>
      <CustomDialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        title="Generate Successfully"
        content={<>
          Data saved successfully!
        </>}
        confirmBtn="OK"
        onConfirm={() => setConfirmationDialogOpen(false)}
      />
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle sx={{ fontSize: '1.5rem', fontWeight: 'bold', padding: '10px' }}>Work Order Affected List</DialogTitle>

        <DialogContent>
          <Grid container spacing={2}>
            exportFunction={() => { }}
            <Grid item xs={12} sx={{ marginBottom: "10px", display: "flex", justifyContent: "flex-end" }}><RefreshExportButtons exportFunction={() => { }} exportData={allWoAffectedRows} title='Work Order Affected' refData={gridApi} handleRefresh={handleGridRefreshFetch} /></Grid>
          </Grid>

          <CustomAgGrid
            ref={gridApi}
            setGridApi={setGridApi}
            rows={allWoAffectedRows}
            columns={resultsColDefs}
            isEnableView={false}
            disableFilter={false}
            headerLayer={2}

          />
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
};
export default AssetServiceChangeList